__turbopack_context__.v({
  "customDropdown": "footer-dropdown-module-scss-module__wvcRWW__customDropdown",
  "customDropdownContainer": "footer-dropdown-module-scss-module__wvcRWW__customDropdownContainer",
  "globeIcon": "footer-dropdown-module-scss-module__wvcRWW__globeIcon",
});
